import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AuthContainerComponent } from '@layout/auth-container/components/auth-container.component';
import { RouterOutlet } from '@angular/router';
import { CopyrightComponent } from '@layout/copyright/components/copyright.component';

@Component({
  selector: 'itc-auth-view',
  templateUrl: 'auth-view.component.html',
  styleUrl: 'auth-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AuthContainerComponent, RouterOutlet, CopyrightComponent],
})
export class AuthViewComponent {}
